<template>
  <div class="self-assessment-form" v-loading="loading">
    <!-- 题目展示 -->
    <div class="subject-wrapper">
      <h2 class="subject-title">{{ formData.appraisalName }}</h2>
      <!-- 考核项统计 -->
      <el-table
        v-if="pageType == 'audit'"
        :data="formTableData"
        border
        style="width: 100%"
        :key="tableKey"
      >
        <el-table-column label="考核科目" min-width="110" prop="name">
        </el-table-column>
        <el-table-column
          v-for="(type, key) in formDataCol"
          :key="key"
          :label="type.colName"
        >
          <template slot-scope="scope">
            <div v-if="scope.$index == 0">
              {{ scope.row[`${type.colName}-value`] }}%
            </div>
            <div v-else>{{ scope.row[`${type.colName}-value`] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="总分" min-width="110">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.$index == 0">{{ scope.row.totalScore }}%</div>
              <div v-else>{{ scope.row.totalScore }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="audit-wrapper">
        <p class="company-name">
          <span>企业名称:{{ formData.companyName }}</span>
          <span v-if="pageType == 'edit'" class="cRed ml20"
            >注：若题目得分=0，可以不输入得分和得分原因</span
          >
        </p>
        <div
          v-if="
            pageType == 'audit' ||
            companyAppraisalSelfStatus == 30 ||
            companyAppraisalSelfStatus == 40
          "
        >
          <el-form
            :model="auditData"
            ref="auditForm"
            :inline="true"
            :key="changeKey"
          >
            <el-row>
              <el-col :span="3" v-if="pageType == 'audit'">
                <el-switch
                  v-model="auditData.companyAppraisalSelfStatus"
                  active-color="#87D068"
                  inactive-color="#FF6600"
                  :active-value="40"
                  :inactive-value="30"
                  :active-text="
                    auditData.companyAppraisalSelfStatus == 30
                      ? '审核不通过'
                      : '审核通过'
                  "
                  @change="changeAuditStatus"
                >
                </el-switch>
              </el-col>
              <!-- 最终得分 -->
              <el-col
                :span="20"
                v-if="
                  auditData.companyAppraisalSelfStatus === 40 &&
                  pageType === 'audit'
                "
              >
                <span>最终得分：</span>
                <el-input class="w70" :disabled="true" v-model="originScore">
                </el-input>
                <span> + </span>
                <el-form-item
                  prop="addScore"
                  :rules="[
                    { required: true, message: '不能为空', trigger: 'blur' },
                    { validator: numValidator, trigger: 'blur' },
                  ]"
                >
                  <el-input
                    class="w180"
                    placeholder="请输入协会评分，可为负值"
                    v-model="auditData.addScore"
                  >
                  </el-input>
                </el-form-item>
                <span> = </span>
                <el-input :disabled="true" class="w70" v-model="totalScore">
                </el-input>
              </el-col>
              <el-col v-if="companyAppraisalSelfStatus == 40">
                <span class="text-success">审核通过</span>
                <span>最终得分：</span>
                <span>{{ Number(formData.sumFraction) }}</span>
              </el-col>
              <!-- 驳回原因 -->
              <el-col
                :span="18"
                v-if="
                  auditData.companyAppraisalSelfStatus === 30 ||
                  companyAppraisalSelfStatus == 30
                "
              >
                <el-form-item
                  prop="rejectionRemark"
                  label="驳回原因"
                  :rules="[
                    { required: true, message: '不能为空', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    :disabled="companyAppraisalSelfStatus == 30"
                    class="w500"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="auditData.rejectionRemark"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <el-form :model="formData" ref="form">
        <div
          class="subject-item"
          v-for="(v, i) in formData.appraisalCheckHeadingList"
          :key="i"
        >
          <p>
            <span> {{ i + 1 }}. {{ `${v.appraisalCheckHeadingContent}` }}</span>
          </p>
          <p>
            <el-form-item :prop="`appraisalCheckHeadingList[${i}].value`">
              <p
                v-for="(item, itemIndex) in v.appraisalCheckAnswerList"
                :key="itemIndex"
              >
                {{ enArr[itemIndex] }}.
                {{ `${item.appraisalCheckAnswerContent}` }}
              </p>
              <el-row>
                <el-col :span="6">
                  <el-input
                    :disabled="pageType == 'edit' ? false : true"
                    v-model="v.answerFractionVO.fraction"
                    placeholder="请输入得分，若是扣分，需要输入'-'负号"
                  ></el-input>
                </el-col>
                <el-col :span="17" class="ml20">
                  <el-input
                    :disabled="pageType == 'edit' ? false : true"
                    v-model="v.answerFractionVO.remark"
                    placeholder="请输入得分原因"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </p>
        </div>
        <div v-if="formData.annexOpen" class="upload-wrapper">
          <span> 材料上传：</span>
          <span class="c666">请上传相关佐证材料，仅支持PDF文档</span>
          <el-upload
            :class="['upload-demo', { 'check-file': pageType != 'edit' }]"
            action="/app/file/upload/file"
            accept=".pdf"
            multiple
            :file-list="uploadFileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div
            :class="['preview', { 'check-file-preview': pageType != 'edit' }]"
          >
            <template v-for="(v, i) in uploadFileList">
              <div :key="i">
                <el-button type="text" @click="preView(v.url)"
                  >点击预览</el-button
                >
              </div>
            </template>
          </div>
        </div>
      </el-form>
    </div>
    <section class="btn-group">
      <el-button @click="goBack()">返回</el-button>
      <el-button @click="submitData()" v-if="pageType == 'edit'"
        >保存草稿</el-button
      >
      <el-button type="primary" @click="submitData(0)" v-if="pageType == 'edit'"
        >提交</el-button
      >
      <el-button
        type="primary"
        @click="submitData(0)"
        v-if="pageType == 'audit'"
        >{{
          auditData.companyAppraisalSelfStatus == 40 ? "提交" : "驳回"
        }}</el-button
      >
    </section>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
// api
import {
  saveCompanyForm,
  saveAuditCompanyForm,
} from "@/api/businessApplication";
export default {
  props: {
    pageType: {
      type: String,
      default: "detail",
    },
  },
  computed: {
    totalScore() {
      return Number(this.originScore) + Number(this.auditData.addScore);
    },
  },
  data() {
    var numValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("不能为空"));
      }
      let reg = /^(-?\d+)(\.\d{1,2})?$/;
      if (!reg.test(value)) {
        callback(new Error("请输入数字，且小数位数最多2位"));
      } else {
        callback();
      }
    };
    return {
      companyAppraisalSelfStatus: "",
      numValidator: numValidator,
      loading: false,
      formData: {}, // 题目数据
      uploadFileList: [], // 附件数据
      formRule: [
        {
          required: true,
          message: "不能为空",
          trigger: "change",
        },
      ],
      appraisalSelfFileList: [],
      //  审核
      changeKey: new Date().getTime(),
      auditData: {
        companyAppraisalSelfStatus: 40,
        addScore: "",
        rejectionRemark: "",
      },
      originScore: 0,
      rejectionRemark: "",

      // 表单数据
      tableKey: new Date().getTime(),
      formTableData: [
        { name: "科目占比" },
        { name: "科目得分" },
        { name: "实际得分" },
      ],
      formDataCol: [],
      enArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },

  mounted() {
    this.companyAppraisalSelfStatus =
      this.$route.query.companyAppraisalSelfStatus;
  },
  methods: {
    // 切换审核状态
    changeAuditStatus(val) {
      this.changeKey = new Date().getTime();
      if (val === 30) {
        this.auditData.addScore = "";
      } else {
        this.auditData.rejectionRemark = "";
      }
    },
    // 上传图片失败handleSuccess
    handleSuccess(res) {
      if (res.code) {
        this.uploadFileList.push({
          url: res.result.fileNameActive,
          name: res.result.fileName,
        });
      }
    },
    // 删除图片
    handleRemove(file) {
      let index = this.uploadFileList.findIndex((v) => v.url == file.url);
      if (index >= 0) {
        this.uploadFileList.splice(index, 1);
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/companySelfAssessmentFrom",
      });
    },
    // PDF预览
    preView(val) {
      window.open(val);
    },
    //------------编辑自评表------------
    //回显数据
    init(data) {
      data.appraisalCheckHeadingList.forEach((v) => {
        if (!v.answerFractionVO) {
          v.answerFractionVO = {};
          v.answerFractionVO.fraction = "";
          v.answerFractionVO.remark = "";
        } else {
          if (v.answerFractionVO.fraction == -9999) {
            v.answerFractionVO.fraction = "";
          }
        }
      });
      this.formData = cloneDeep(data);
      this.auditData.rejectionRemark = data.rejectionRemark;
      // 附件信息
      this.uploadFileList = cloneDeep(data.answerAppraisalSelfFileList);
      // 统计分数
      if (this.pageType == "audit") {
        let totalScore = 0;
        let totalRateScore = 0;
        let actualTotalScore = 0;
        data.appraisalTopGroupFractionList.forEach((v) => {
          totalScore += Number(v.fraction);
          totalRateScore += Number(v.proportionStr);
          actualTotalScore += Number(v.actualFraction);
          this.formDataCol.push({
            colName: v.content,
            prop: v.fraction,
          });
          this.formTableData[0][`${v.content}-value`] = Number(v.proportionStr); // 占比
          this.formTableData[1][`${v.content}-value`] = Number(v.fraction); // 分数
          this.formTableData[2][`${v.content}-value`] = Number(
            v.actualFraction
          );
          // 实际分数
        });
        this.formTableData[0].totalScore = totalRateScore;
        this.formTableData[1].totalScore = totalScore;
        this.formTableData[2].totalScore = actualTotalScore;
        this.originScore = actualTotalScore;
      }
    },
    // 组装参数
    getSubmitParams(type) {
      let params = {
        appraisalSelfId: this.formData.appraisalSelfId,
        companyAppraisalSelfId: this.formData.companyAppraisalSelfId,
        companyAppraisalAnswerList: [],
        appraisalSelfFileList: cloneDeep(this.uploadFileList),
        companyAppraisalSelfStatus: type,
      };
      this.formData.appraisalCheckHeadingList.forEach((v) => {
        let obj = {
          appraisalCheckHeadingId: v.appraisalCheckHeadingId,
          fraction:
            v.answerFractionVO.fraction == ""
              ? ""
              : Number(v.answerFractionVO.fraction),
          remark: v.answerFractionVO.remark,
        };
        params.companyAppraisalAnswerList.push(obj);
      });
      return params;
    },
    // 提交
    async submitData(type) {
      // 组装参数
      let params = this.getSubmitParams(type);
      // 填写数据
      if (this.pageType === "edit") {
        if (type === 0) {
          this.$refs.form.validate(async (valid) => {
            if (valid) {
              this.$confirm(
                "确定提交申请，提交后表单将不可修改？",
                "提交确认",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  type: "warning",
                }
              )
                .then(async () => {
                  let res = await saveCompanyForm(params);
                  if (res.code) {
                    this.goBack();
                  } else {
                    this.$message.warning(res.message);
                  }
                })
                .catch(() => {});
            }
          });
        } else {
          let res = await saveCompanyForm(params);
          if (res.code) {
            this.goBack();
          } else {
            this.$message.error(res.result);
          }
        }
      }
      // 审核数据
      if (this.pageType === "audit") {
        this.$refs.auditForm.validate(async (valid) => {
          if (valid) {
            let auditParams = {
              addScore: this.auditData.addScore,
              companyAppraisalSelfStatus:
                this.auditData.companyAppraisalSelfStatus,
              rejectionRemark: this.auditData.rejectionRemark,
              companyAppraisalSelfId: this.formData.companyAppraisalSelfId,
            };
            this.$confirm(
              `确定${
                this.auditData.companyAppraisalSelfStatus == 40
                  ? "通过"
                  : "驳回"
              }审核，确定后表单状态不可退回`,
              `${
                this.auditData.companyAppraisalSelfStatus == 40
                  ? "通过"
                  : "驳回"
              }确认`,
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                let res = await saveAuditCompanyForm(auditParams);
                if (res.code) {
                  this.goBack();
                } else {
                  this.$message.error(res.result);
                }
              })
              .catch(() => {});
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cRed {
  margin-right: 5px;
  color: red;
}
.c666 {
  color: #666;
}
.w70 {
  width: 70px;
}
.w180 {
  width: 180px;
}
.w500 {
  width: 500px;
}
.ml20 {
  margin-left: 20px;
}
.text-success {
  color: #87d068;
  margin-right: 20px;
}
.audit-wrapper {
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.company-name {
  margin: 0;
  padding: 20px 0;
}
.self-assessment-form {
  .btn-group {
    width: calc(100% - 70px);
    padding: 15px;
    text-align: center;
    position: absolute;
    left: 20px;
    bottom: 0px;
    background: #fff;
    box-shadow: 0 0 10px #eee;
  }
}

//  问卷
.subject-wrapper {
  padding: 20px 50px;
  padding-bottom: 50px;
  margin-bottom: 80px;
  .subject-title {
    text-align: center;
    font-size: 24px;
  }
  .subject-item {
    margin-bottom: 30px;
    border-bottom: 1px solid #efefef;
    /deep/ .el-radio-group {
      width: 100%;
    }
    /deep/ .el-radio {
      display: block !important;
      width: 100%;
      margin-top: 5px;
      .el-radio__label {
        display: inline-block;
        width: calc(100% - 0px);
        > span {
          display: block;
          width: 100%;
          word-wrap: break-word;
          white-space: pre-line;
        }
      }
    }
  }
  /deep/ .el-form-item__content {
    padding-left: 20px !important;
  }
}

.upload-wrapper {
  position: relative;
  /deep/ .upload-demo {
    width: 50%;
    margin-top: 20px;
    &.check-file {
      .el-button {
        display: none;
      }
      .el-upload-list__item {
        .el-icon-upload-success {
          display: none;
        }
        &:hover {
          background: transparent;
          .el-icon-close {
            display: none !important;
            opacity: 0 !important;
          }
        }
      }
    }
  }
  .preview {
    position: absolute;
    top: 77px;
    left: calc(50% - 90px);
    &.check-file-preview {
      top: 60px !important;
    }
  }
}
</style>
